import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: theme => ({
    backgroundColor: theme.colors.backgroundColor,
  }),
  quickActionMenuHeaderStyle: {
    marginTop: 8,
    marginHorizontal: 16,
  },
  quickActionMenuContainerStyle: theme => ({
    paddingHorizontal: 0,
    backgroundColor: theme.colors.backgroundColor
  }),
  modalView: theme => ({
    minWidth: '650px',
    maxWidth: '650px',
    height: 'auto',
    backgroundColor: theme.colors.quickActionGradientColors.secondary,
    margin: 'auto',
    padding: 20,
    borderRadius: "7px",
  })
})
